var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, Fragment, useState } from "react";
import { SecondaryAppBar } from "../../common/SecondaryAppBar";
import { casesService } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { loadActivities } from "../../../redux/actions";
import { selectActivities, selectComplaint } from "../../../redux/selectors";
import { Flagged } from "./activityTypes/Flagged";
import { OutcomeDocsToggle } from "./activityTypes/OutcomeDocs";
import { ActivitiesSegments } from "./ActivitiesSegments";
import { ActivitiesFooter } from "./ActivitiesFooter";
import { useAuthorizationForCase } from "../../../hooks/useAuthorization";
import { CaseRoles } from "../../../auth/CaseRoles";
import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { GetApp, Timer } from "@material-ui/icons";
import fileDownload from "js-file-download";
import { CaseAllocation } from "../../analyticsDashboard/CaseAllocation";
import { Link } from "react-router-dom";
import { SlaOverrideDialog } from "./dialogs/SlaOverrideDialog";
export const ActivitiesActions = () => {
    var _a;
    const dispatch = useDispatch();
    const { requestedState } = useSelector(selectActivities);
    const caseState = useSelector(selectComplaint);
    const caseId = (_a = caseState === null || caseState === void 0 ? void 0 : caseState.data) === null || _a === void 0 ? void 0 : _a.id;
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const folder = yield casesService.downloadExport(caseId);
        fileDownload(folder, `${(_b = caseState === null || caseState === void 0 ? void 0 : caseState.data) === null || _b === void 0 ? void 0 : _b.ofqualId} - ${new Date(Date.now()).toLocaleString()}.zip`);
    });
    return caseId ? (React.createElement(Fragment, null,
        React.createElement(OutcomeDocsToggle, { title: requestedState.outcomeDocsOnly ? "Show all" : "Show outcome documents", isSelected: requestedState.outcomeDocsOnly, onClick: () => dispatch(loadActivities(caseId, { outcomeDocsOnly: !requestedState.outcomeDocsOnly })), hook: "activity-outcome-doc-toggler" }),
        React.createElement(Flagged, { title: requestedState.flagged ? "Show all" : "Show flagged", isFlagged: requestedState.flagged, onClick: () => dispatch(loadActivities(caseId, { flagged: !requestedState.flagged })), hook: "activity-toggler" }),
        React.createElement(Tooltip, { title: "Export case" },
            React.createElement(IconButton, { className: "Export", onClick: () => onClick(), "data-test": "export" },
                React.createElement(GetApp, { fontSize: "default" }))))) : (React.createElement(Fragment, null));
};
export const Activities = ({ model }) => {
    var _a;
    const dispatch = useDispatch();
    const { requestedState } = useSelector(selectActivities);
    const caseState = useSelector(selectComplaint);
    const [openDialog, setOpenDialog] = useState(false);
    useEffect(() => {
        dispatch(loadActivities(model.id, {}));
    }, [model, dispatch]);
    const { data, loadingState, caseId: caseIdFromState } = useSelector(selectActivities);
    const [readyCount, setReadyCount] = useState(0);
    const onIsReady = () => {
        setReadyCount(readyCount + 1);
    };
    const isReady = readyCount === (data === null || data === void 0 ? void 0 : data.length);
    useEffect(() => {
        window.scrollTo(0, window.document.body.scrollHeight);
    }, [
        loadingState,
        isReady, // when all skeletons are ready we scroll to bottom
    ]);
    const isAuthedForActivityEdit = useAuthorizationForCase(model.id, CaseRoles.admin);
    return (React.createElement(Fragment, null,
        React.createElement(SecondaryAppBar, { hasSubBar: true, title: React.createElement(React.Fragment, null,
                React.createElement(Link, { to: `/complaints/list`, "data-test-id": "secondary-header-root-link" }, "/ All cases"),
                " ",
                "/ ",
                model.title), actions: loadingState === "LOADED" && ((_a = caseState === null || caseState === void 0 ? void 0 : caseState.data) === null || _a === void 0 ? void 0 : _a.status) === "Active"
                ? [
                    {
                        onClick: () => setOpenDialog(true),
                        startIcon: React.createElement(Timer, null),
                        disabled: false,
                        "data-test": "sla-overrides",
                    },
                ]
                : [] },
            React.createElement(CaseAllocation, null),
            loadingState === "LOADING" && React.createElement(CircularProgress, { size: 24, color: "secondary" })),
        React.createElement("div", { "data-test": "activities" },
            !!data.length && model.id === caseIdFromState && (React.createElement(ActivitiesSegments, { activities: data, disabled: !isAuthedForActivityEdit, onIsReady: onIsReady })),
            !data.length && model.id === caseIdFromState && (React.createElement("div", null,
                !requestedState.flagged && !requestedState.outcomeDocsOnly && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "EmptyBodyText" }, "No case activity recorded yet."),
                    React.createElement("p", { className: "EmptyBodySubText" }, "Use the buttons below to record activity against this case."))),
                requestedState.flagged && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "EmptyBodyText" }, "No flagged case activities"),
                    React.createElement("p", { className: "EmptyBodySubText" },
                        React.createElement("a", { className: "linkButton", onClick: () => {
                                var _a;
                                return dispatch(loadActivities((_a = caseState === null || caseState === void 0 ? void 0 : caseState.data) === null || _a === void 0 ? void 0 : _a.id, { flagged: !requestedState.flagged }));
                            } }, "Show all activities")))),
                requestedState.outcomeDocsOnly && !requestedState.flagged && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "EmptyBodyText" }, "No outcome document activities"),
                    React.createElement("p", { className: "EmptyBodySubText" },
                        React.createElement("a", { className: "linkButton", onClick: () => {
                                var _a;
                                return dispatch(loadActivities((_a = caseState === null || caseState === void 0 ? void 0 : caseState.data) === null || _a === void 0 ? void 0 : _a.id, {
                                    outcomeDocsOnly: !requestedState.outcomeDocsOnly,
                                }));
                            } }, "Show all activities"))))))),
        React.createElement(ActivitiesFooter, { model: model }),
        openDialog ? (React.createElement(SlaOverrideDialog, { caseModel: model, isDialogOpen: openDialog, onDialogClose: () => setOpenDialog(false) })) : null));
};
